module.exports = __webpack_public_path__ + "static/media/our-process.5e965325.png";